import styled from 'styled-components';

type StyledContainerProps = {
    $width?: string;
};

export const StyledContainer = styled.div<StyledContainerProps>`
    display: flex;
    flex-grow: 1;
    width: ${props => props.$width || '100%'};
`;